import {
  OasError,
  OasErrorConstructor,
  getOasErrorFromError,
  OasErrorOptions,
  OasErrorInterface,
} from './oas-error';

export const OasRoutingError: OasErrorConstructor = class OasRoutingError extends OasError {
  static fromError(e: unknown, options?: OasErrorOptions): OasErrorInterface {
    return getOasErrorFromError(OasRoutingError, e, options);
  }

  constructor(message?: string, options?: OasErrorOptions) {
    super(message, { ...options, type: 'OasRoutingError' });
  }
};
